@if (office) {
  <app-office-form
    [office]="office"
    action="{{ 'edit' | translate }}"
    (close)="closeForm($event)">
  </app-office-form>
}
